import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { SettingsBranchDefaultDetailsModel } from "../../../model/settings/SettingsChangeDefaultBranchModel";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ShowToast from "../../../widget/common/ui/Toast";

const SettingsProvider = new (class SettingsProvider {
  getBranchDefaulInfoAPI =
    async (): Promise<SettingsBranchDefaultDetailsModel | null> => {
      ApiUrls.init();
      const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
      const url: string = `${ApiUrls.baseUrl}profile/get_default_branch_details`;
      const body: any = {
        account_id: accountId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsBranchDefaultDetailsModel: SettingsBranchDefaultDetailsModel =
            response;
          return settingsBranchDefaultDetailsModel;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

  updateDefaultBranchAPI = async (branchId: string = ""): Promise<boolean> => {
    ApiUrls.init();

    if (UtilityHelper.isNotEmpty(branchId)) {
      const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
      const url: string = `${ApiUrls.baseUrl}profile/set_default_branch`;
      const body: any = {
        account_id: accountId,
        branch_id: branchId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          /* const signupBranchModel: SignupBranchModel = response;
          const defaultBranch: DefaultBranch =
            signupBranchModel?.result?.default_branch!; */

          return true;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }
    }

    return false;
  };
})();

export default SettingsProvider;
